import { useTranslation } from 'react-i18next';
import { KoobInputSelect } from '@koob/ui';
import { useSetTripFilters, useTripFilters } from '@koob/trip-designer';

const statuses = [
  { label: 'NEW', displayName: 'new' },
  { label: 'PENDING DMC', displayName: 'pending_dmc' },
  { label: 'PENDING TO', displayName: 'pending_to' },
  { label: 'CLOSED', displayName: 'closed' },
];

const options = statuses.map(status => ({
  value: status.displayName,
  label: status.label,
}));

// Chat mode: filters the conversations by status.
const ChatStatusFilter = () => {
  const { t } = useTranslation('tripDesigner');
  const tripFilters = useTripFilters();
  const setTripFilters = useSetTripFilters();

  return (
    <div className="relative flex gap-1.5 max-w-screen-2xl flex-wrap">
      <div>
        <KoobInputSelect
          searchable
          clearable
          rounded="full"
          placeholder={t('search.conversationStatus')}
          options={options}
          value={tripFilters?.conversationStatus?.displayName}
          onValueChange={v =>
            setTripFilters(current => ({
              ...current,
              conversationStatus:
                statuses.find(status => status.displayName === v) ?? null,
            }))
          }
          style={{ minWidth: 200 }}
        />
      </div>
    </div>
  );
};

export default ChatStatusFilter;
